import ApiClient from '@/components/api-client'
import { isUndefined, isNull, includes } from 'lodash'

const state = {
  encryptedId: null,
  settings: {}
}

const mutations = {
  setBrand (state, brand) {
    state.settings = brand
    if (!state.encryptedId) {
      state.encryptedId = brand.encryptedId
    }
  },
  setBrandEncryptedId (state, encryptedId) {
    state.encryptedId = encryptedId
  }
}

const actions = {
  loadBrand ({commit, state, rootState}, slug) {
    return ApiClient.getBrand(slug)
      .then(
        response => {
          commit('setBrand', response.data)
          if (response.data && !rootState.user.isAnonymous && !rootState.user.isGdprCovered) {
            if (!isUndefined(window.pendo)) {
              // eslint-disable-next-line
              pendo.initialize({
                visitor: {
                  id: rootState.user.id + 'CQ',
                  email: rootState.user.email,
                  first_name: rootState.user.firstName,
                  last_name: rootState.user.lastName,
                  session_type: isNull(rootState.user.isImpersonating) ? 'impersonating' : 'normal'
                },
                account: {
                  id: response.data.id + 'CQ',
                  name: response.data.name
                }
              })
            }

            if (!isUndefined(window.FS)) {
              // eslint-disable-next-line
              FS.identify(rootState.user.id, {
                displayName: rootState.user.firstName + ' ' + rootState.user.lastName,
                email: rootState.user.email,
                // TODO: Add your own custom user variables here, details at
                // http://help.fullstory.com/develop-js/setuservars
                platform_str: 'Nativo IQ',
                isAdmin_bool: rootState.user.roles.includes('admin')
              })
            }
          }

          return state.settings
        }
      )
  },
  loadBrandPublic ({commit, state}) {
    return ApiClient.getBrandPublic(state.encryptedId)
      .then(response => {
        commit('setBrand', response.data)
        return state.settings
      })
  }

}

const getters = {
  getBrand: state => {
    return state.settings
  },
  brandId: state => {
    return state.settings.id
  },
  brandsAsOptions: ({ settings }) =>
    settings.competitors
      .map(obj => ({
        label: obj.name,
        value: String(obj.id)
      }))
      .concat([ { label: settings.name, value: String(settings.id) } ]),
  squareLogoUrl: state => brandIds => {
    if (includes(brandIds, state.settings.id)) {
      return state.settings.squareLogoUrl
    }

    const competitor = state.settings.competitors.find(c => includes(brandIds, c.id))

    if ( competitor ) { return competitor.squareLogoUrl }

    return null
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
